import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { CampaignStyleProps } from './Campaign.interface';

export const GridWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(4, auto);
    justify-content: center;
    margin: ${({ theme }) => theme.spacing * 20}px 
        0 ${({ theme }) => theme.spacing * 8}px;
    grid-gap: 0 16px;
    @media screen and (max-width: 960px) {
        grid-template-columns: repeat(2, auto);
        grid-gap: 16px;
        margin-top: ${({ theme }) => theme.spacing * 10}px;
    }
    @media screen and (max-width: 690px) {
        grid-template-columns: 100%;
        grid-gap: 16px 0;
    }
`;

export const Item = styled.div`
    width: 220px;
    border-radius: 6px;
    background-color: ${({ theme }) => theme.colors.darkBlueAlpha};
    box-sizing: border-box;
    padding: ${({ theme }) => theme.spacing * 4}px
        ${({ theme }) => theme.spacing * 6}px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    @media screen and (max-width: 690px) {
        width: 100%;
    }
`;

export const ItemTitle = styled.h3<CampaignStyleProps>`
    margin: 0;
    color: ${({ theme }) => theme.colors.grayAlpha};
    line-height: 24px;
    font-size: 16px;
    margin-bottom: ${({ theme }) => theme.spacing * 6}px;
    margin-top: ${props => props.margin ? '28px': '0' };
`;

export const Circle = styled.div`
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: #44D7B6;
    margin-top: ${({ theme }) => theme.spacing * 2}px;
`;

export const Description = styled.p`
    margin: 0 0 0 ${({ theme }) => theme.spacing * 2}px;
    color: ${({ theme }) => theme.colors.grayAlpha};
    opacity: .87;
    line-height: 21px;
    font-size: 14px;
`;

export const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 7px auto;
    min-height: 21px;
    margin-bottom: ${({ theme }) => theme.spacing * 4}px;
`;

export const ActiveInfo = styled.p`
    margin: 0;
    text-align: right;
    color: ${({ theme }) => theme.colors.blue};
    opacity: .45;
    font-size: 10px;
    font-weight: bold;
    line-height: 12px;
    margin-bottom: ${({ theme }) => theme.spacing * 4}px;
    text-transform: uppercase;
`;

export const StyledLink = styled(Link)<CampaignStyleProps>`
    text-transform: uppercase;
    text-align: right;
    color: ${props => props.disabled ? '#062B54' : '#448AFF'};
    font-size: 10px;
    font-weight: bold;
    line-height: 16px;
    display: block;
    text-decoration: none;
    ${props => props.disabled && 'pointer-events: none'};
    ${props => props.disabled && 'opacity: .45'};

`;
